import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useCallback,
} from "react";
import { connect } from "react-redux";
import {
  TextField,
  Button,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormGroup,
  ThemeProvider,
  Checkbox,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  CircularProgress,
  Container,
  Tooltip,
} from "@material-ui/core";
import { setUserProfile } from "../../../../redux/actions/authActions";
import { Field, reduxForm, getFormValues, change } from "redux-form";
import { ButtonToolbar } from "reactstrap";
import ExpandMoreIcon from "mdi-react/ExpandMoreIcon";
import { withStyles } from "@material-ui/core/styles";
import { Switch, Typography } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import SnackBar from "../../../../shared/components/SimpleSnackBar";
import { Link } from "react-router-dom";
import JoditEditor from "jodit-react";
import { matTheme } from "../../../../shared/helpers/utils";
import FileDocumentEditOutlineIcon from "mdi-react/FileDocumentEditOutlineIcon";
import ClearIcon from "mdi-react/TrashCanOutlineIcon";
import UpdateIcon from "mdi-react/ContentSaveEditOutlineIcon";
import renderDropZoneField from "../../../Profile/components/DropZone";
import LinearLoading from "../../../../shared/components/LinearLoading";
import { _capitalizeText } from "../../../../shared/helpers/utils";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import { height, textAlign } from "@material-ui/system";
import LogoIcon from "mdi-react/StarBoxOutlineIcon";
import SummaryIcon from "mdi-react/FileDocumentEditOutlineIcon";
import DetailsIcon from "mdi-react/FormatListCheckboxIcon";
import ChartIcon from "mdi-react/ChartAreasplineIcon";
import MapIcon from "mdi-react/MapMarkerIcon";
import ThemeIcon from "mdi-react/PaletteIcon";
import CircleIcon from "mdi-react/CircleOutlineIcon";
import CheckCircleIcon from "mdi-react/CheckCircleOutlineIcon";
import { HexColorPicker, HexColorInput } from "react-colorful";

import { Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";

import { fade, makeStyles } from "@material-ui/core/styles";
import GeneralBuildingSearchBar from "../../../../shared/components/building_filters/GeneralBuildingSearchBar";
import { themes } from "./utils";
import Slider from "react-slick";
import { customStyles } from "./utils";
import ArrowRightIcon from "mdi-react/ArrowRightDropCircleIcon";
import ArrowLeftIcon from "mdi-react/ArrowLeftDropCircleIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
const apiUrl = process.env.API_ROOT + "/";

const styles = (theme) => ({
  container: {
    display: "flex",
    gap: "3rem",
    maxWidth: 1000,
    justifyContent:"center",
    padding:0,
    "& .material-form__label.bold": {
      color: "#FFF",
    },
    "& .sub-text": {
      color: "#FFF",
      fontSize: 13,
    },
    "& .MuiTypography-root": {
      color: "#FFF",
    },
    "& .link-text": {
      color: "#FFF",
    },
    "& .logo-container": {
      background: "#FFF",
      padding: 10,
      border: "1px double #FFF",
      borderRadius:8,
      boxShadow:
        "rgba(0, 0, 0, 0.3) 0px 0px 1px -3px, rgba(0, 0, 0, 0.3) 0px 1px 2px 0px, rgba(0, 0, 0, 0.3) 0px 1px 4px 0px",
      outline: "1px solid #eff1f5",
      // backgroundImage:
      //   "linear-gradient(-45deg, #eff1f5 25%, transparent 25%, transparent 50%, #eff1f5 50%, #eff1f5 75%, transparent 75%, transparent)",
      backgroundSize: "30px 30px",
    },
  },
  root: {
    flexDirection: "column",
    alignItems: "left",
    textAlign: "left",
    padding: "20px 20px 10px",
    border: "1px solid #FFF",
    borderRadius: 10,
    background: "rgba(0, 0, 0, 0.07)",
    margin: "20px 0",
  },
  ExpansionPanelSummary: {
    background: "#F5F7FA",
    border: "1px solid #780F9E",
    marginBottom: 5,
  },
  PanelTitle: {
    fontWeight: 600,
    fontSize: 17,
  },
  button: {
    "&.selected": {
      background: "#780F9E",
      color: "#FFF",
    },
    fontSize: 14,
    margin: "0 5px 0 0",
  },
  ".btn-toolbar": {
    justifyContent: "center",
  },
  growElement: {
    // transition: "width 1s ease",
    width: "0%",
    height: "0px",
    overflow: "hidden",
  },
  expanded: {
    height: "auto",
    width: "100%",
    margin: "0px 0",
  },
  switchLabel: {
    display: "flex",
    alignItems: "center",
  },
  onLabel: {
    marginLeft: 8,
    color: "#780F9E",
    fontWeight: "bold",
    marginRight: "10px !important",
    marginTop: "-5px !important",
  },
  offLabel: {
    marginRight: 8,
    color: "#999",
    fontWeight: "bold",
    marginRight: "10px !important",
    marginTop: "-5px !important",
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#780F9E",
      "& + .MuiSwitch-track": {
        backgroundColor: "#780F9E",
      },
    },
  },
  switchTrack: {
    backgroundColor: "#999",
  },
  themeBar: {
    maxWidth: "1000px",
    textAlign: "left",
    margin: "0 auto",
    text: "#FFF",
    "& .material-form__label": {
      color: "#FFF",
    },
    "& .slick-slider .slick-arrow.slick-next": {
      background: "transparent",
      color: "#DBE0E8",
    },
    "& .slick-slider .slick-arrow.slick-prev": {
      background: "transparent",
      color: "#DBE0E8",
    },
  },
});

const searchBarStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#FFF !important",
    transform: "none !important",
    color: "#222 !important",
    boxShadow: "none",
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: "-24px !important",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0, //theme.spacing(3),
      width: "90%",
      maxWidth: 800,
    },
    border: "1px solid #222",
    "& .c_nav-input": {
      color: "#222 !important",
    },
    "& .c_clear-search": {
      color: "#222 !important",
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "#222 !important",
    width: "100%",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7) + " !important",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "80%",
    },
    color: "#222 !important",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));
const detailOptions = {
  "no-details": "No Details",
  "latest-50": "Show Latest Activity - 30 Max",
  "top-50": "Show Top Activity by Price - 30 Max",
};

const WhiteRadio = withStyles({
  root: {
    color: "white",
    "&$checked": {
      color: "white",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);
const ExportSettingsForm = (props) => {
  const {
    t,
    user,
    classes,
    setPreview,
    reportParams,
    setParentFetchInProgress,
    formValues,
    setFormValues,
    handleAI,
    aiInProgress,
    aiRun,
    formValuesCheckboxes,
    setFormValuesCheckboxes,
    setReportData,
    panel,
    setSubmit,
    submit,
    isDrawerOpen,
    color,
    setColor,
    selectedFont,
    setSelectedFont,
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    reportItem
  } = props;
   const  storedFormValues = JSON.parse(localStorage.getItem("formValues"));
  const [localFormValues, setLocalFormValues] = useState(formValues);
  const [fetchInProgress, setFetchInProgress] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);

  const editorRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [isBrandLogoAvailable, setIsBrandLogoAvailable] = useState(!user.logo);
  const [snackShow, setSnackShow] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [isBackgroundColorPickerOpen, setIsBackgroundColorPickerOpen] = useState(false);
  const [isTextColorPickerOpen, setIsTextColorPickerOpen] = useState(false);
  
  const [advancedTheme, setAdvancedTheme] = useState(localFormValues &&
     localFormValues.theme &&
     localFormValues.theme == "custom");

  const colorPickerRef = useRef(null);
  const backgroundColorPickerRef = useRef(null);
  const textColorPickerRef = useRef(null);
  const brandingFromStorage=localStorage.getItem("branding");
  const contactFromStorage=localStorage.getItem("contact")
  const handleAfterChange = (currentSlide) => {
    // Determine if the custom theme card is in view
    const themeKeys = Object.keys(themes);
    const customThemeIndex = themeKeys.indexOf("custom");

    // Get the number of slides to show based on the current screen width
    let slidesToShow = 6; // default value
    const screenWidth = window.innerWidth;

    if (screenWidth < 768) {
      slidesToShow = 3;
    } else if (screenWidth < 992) {
      slidesToShow = 5;
    } else if (screenWidth < 1200) {
      slidesToShow = 6;
    } else if (screenWidth < 1536) {
      slidesToShow = 6;
    } else {
      slidesToShow = 6;
    }

    const visibleSlides = [];
    for (let i = currentSlide; i < currentSlide + slidesToShow; i++) {
      visibleSlides.push(i);
    }

    if (!visibleSlides.includes(customThemeIndex)) {
      setIsColorPickerOpen(false);
      setIsBackgroundColorPickerOpen(false);
      setIsTextColorPickerOpen(false);
    }
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    swipeToSlide: true,
    prevArrow: <ArrowLeftIcon size={30} fill="#000" />,
    nextArrow: <ArrowRightIcon size={30} fill="#000" />,
    afterChange: handleAfterChange, // Add this line
    slidesToScroll: 4,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 1536, settings: { slidesToShow: 5 } },
      { breakpoint: 100000, settings: { slidesToShow: 5 } },
    ],
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(event.target)
      ) {
        setIsColorPickerOpen(false);
      }
      
    }

    if (isColorPickerOpen || isBackgroundColorPickerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isColorPickerOpen]);
  
  useEffect(() => {
    function handleClickOutsideBackground(event) {
      
      if (
        backgroundColorPickerRef.current &&
        !backgroundColorPickerRef.current.contains(event.target)
      ) {
        setIsBackgroundColorPickerOpen(false);
      }
    }
  
    if (isBackgroundColorPickerOpen) {
      document.addEventListener("mousedown", handleClickOutsideBackground);
    }
    
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideBackground);
    };
  }, [isBackgroundColorPickerOpen]);
  
  useEffect(() => {
    function handleClickOutsideText(event) {
      
      if (
        textColorPickerRef.current &&
        !textColorPickerRef.current.contains(event.target)
      ) {
        setIsTextColorPickerOpen(false);
      }
    }
  
    if (isTextColorPickerOpen) {
      document.addEventListener("mousedown", handleClickOutsideText);
    }
    
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideText);
    };
  }, [isTextColorPickerOpen]);

  useEffect(() => {
    setParentFetchInProgress(fetchInProgress);
  }, [fetchInProgress]);

  useEffect(() => {
    if (formValues.theme && formValues.theme == "custom") {
      //setIsColorPickerOpen(true);
    }
  }, [formValues && formValues.theme]);

  useEffect(() => {
    setLocalFormValues(formValues);
    if (formValues.aiRefresh) {
      setPreview();
    }
  }, [formValues]);
  const snackOpen = (message, type) => {
    setSnackShow({ show: true, message, type });
  };
  useEffect(() => {
    if (isBrandLogoAvailable) {
      // Trigger the expansion effect after the component is rendered
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  }, [isBrandLogoAvailable]);
  const handleFieldChange = (field, value) => {
    setLocalFormValues((prevState) => ({ ...prevState, [field]: value }));
    setFormValues((prevState) => ({ ...prevState, [field]: value }));
   value &&  localStorage.setItem(`${field}`, value);
    setPreview();

  };

  useEffect(() => {
    //console.log("color changed", color, localFormValues.theme) 
    if (localFormValues && localFormValues.theme === "custom") {
      // Create a timeout to delay the function call
    
      const timeoutId = setTimeout(() => {
        
        handleFieldChange("customColor", color);
        setPreview();
      }, 300); // Adjust the timeout delay as needed (300ms in this case)

      // Cleanup the timeout if color changes before the delay completes
      return () => clearTimeout(timeoutId);
    }
  }, [color]);
  
  useEffect(() => {
   // console.log("backgroundColor changed", backgroundColor, localFormValues.theme)
    if (localFormValues && localFormValues.theme === "custom") {
      // Create a timeout to delay the function call
      const timeoutId = setTimeout(() => {
       // console.log("timeout backgroundColor color changed", backgroundColor)
        handleFieldChange("customBackgroundColor", backgroundColor);
        setPreview();
      }, 300); // Adjust the timeout delay as needed (300ms in this case)
  
      // Cleanup the timeout if color changes before the delay completes
      return () => clearTimeout(timeoutId);
    }
  }, [backgroundColor]);
  
  useEffect(() => {
   // console.log("backgroundColor changed", backgroundColor, localFormValues.theme)
    if (localFormValues && localFormValues.theme === "custom") {
      // Create a timeout to delay the function call
      const timeoutId = setTimeout(() => {
       // console.log("timeout backgroundColor color changed", backgroundColor)
        handleFieldChange("customTextColor", textColor);
        setPreview();
      }, 300); // Adjust the timeout delay as needed (300ms in this case)
  
      // Cleanup the timeout if color changes before the delay completes
      return () => clearTimeout(timeoutId);
    }
  }, [textColor]);

  const handleLocalFieldChange = (field, value) => {
    setLocalFormValues((prevState) => ({ ...prevState, [field]: value }));
  };

  const handleSave = () => {
    setFormValues(localFormValues);
    setPreview();
  };

  const handleEditorChange = (field, value) => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    handleLocalFieldChange(field, value);
    const newTimeout = setTimeout(() => {
      setFormValues((prevState) => ({ ...prevState, [field]: value }));
      setPreview();
    }, 500);

    setTypingTimeout(newTimeout);
  };

  const clearField = (field) => {
    setLocalFormValues((prevState) => ({ ...prevState, summary: "" }));
    setFormValues((prevState) => ({ ...prevState, summary: "" }));
    setPreview();
  };
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (checked) {
      setFormValuesCheckboxes((prev) => [...prev, name]);
    } else {
      setFormValuesCheckboxes((prev) => prev.filter((item) => item !== name));
    }
  };

  const handleSaveLogo = async (logo) => {
    const oktaToken = process.env.OKTA_TOKEN;
    const apiUrl = process.env.API_ROOT + "/buyerslist/"; //'http://localhost:8000/buyerslist/';
    const { dispatch, user } = props;
    let headers = {
      Authorization: `SSWS ${oktaToken}`,
    };
    const { formLogo } = props;
    let profile = Object.assign({}, user);
    const user_id = profile.id;

    if (logo && logo != "") {
      profile.logo = logo;
    } else {
      profile.logo = "";
    }

    let userData = {
      url: apiUrl + "user/update",
      method: "post",
      query: {
        id: user_id,
        profile: profile,
      },
    };

    _axiosCall(userData)
      .then((res) => {
        console.log("_getUserData res back ,", res);

        if (res && res.profile) {
          let oktaUser = Object.assign({}, res.profile);
          oktaUser["id"] = res.id;
          dispatch(setUserProfile(oktaUser));
          //snackOpen("Your logo has been uploaded to your profile.");

          if (logo) {
            setFormValues((prev) => ({ ...prev, branding: "mylogo" }));
            handleFieldChange("branding", "mylogo");
            setIsBrandLogoAvailable(false);
          } else {
            setFormValues((prev) => ({ ...prev, branding: "marketproof" }));
          }
        } else {
          if (res.message) {
            snackOpen(
              <Fragment>
                <span>
                  Oops, Your Profile Was Not Updated.{" "}
                  <p
                    className="small-text light-text"
                    style={{ marginLeft: "30px", color: "#FFF" }}
                  >
                    {_capitalizeText(res.message)}
                  </p>
                </span>
              </Fragment>,
              "error"
            );
          } else {
            this.snackOpen(
              "Oops, Something Went Wrong, Your Profile Was Not Updated.",
              "error"
            );
          }
        }
      })
      .catch((error) => {
        console.log("_getUserData error ", error);
        snackOpen(
          "Oops, Something Went Wrong, Your Profile Was Not Updated.",
          "error"
        );
      });
  };
  const snackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackShow({ show: false, message: "" });
  };

  const selectedTheme =
    localFormValues && localFormValues.theme
      ? localFormValues.theme
      : "default";
  const selectedStyle = localFormValues.style;
  const googleFonts = [
    "Roboto",
    "Open Sans",
    "Lato",
    "Montserrat",
    "Oswald",
    "Source Sans Pro",
    "Raleway",
    "Noto Sans",
    "Nunito",
    "Poppins",
  ];
  
  let brandValue = brandingFromStorage ||localFormValues.branding || "marketproof";
  if(reportItem && reportItem.hideMarektproofBranding && brandValue == "marketproof"){
    brandValue = "hide";
  }
  
  return (
    <>
      {" "}
      {console.log(panel, "panel")}
      <form className="material-form">
        {panel == "branding" ? (
          <Container className={classes.container}>
            <div className={classes.root} style={{ width: 500 }}>
              <div
                style={
                  isExpanded ? { marginBottom: 0 } : { marginBottom: "20px" }
                }
              >
                <div className="mb-2">
                  <span className="material-form__label bold">
                    {user && user.logo ? "Select Logo" : "Add Your Logo"}
                  </span>
                 
                  <hr />
                </div>
              </div>

              <RadioGroup
                aria-label="branding"
                name="branding"
                value={brandValue}
                onChange={(e) => {
                  handleFieldChange("branding", e.target.value);
                  setIsBrandLogoAvailable(false);
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {user && user.logo && !isExpanded && (
                  <div style={{ width: "100%" }}>
                    <FormControlLabel
                      value="mylogo"
                      control={<WhiteRadio />}
                      label={
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div className="logo-container">
                            <img
                              src={user.logo}
                              style={{ width: 160 }}
                              alt="User Logo"
                            />
                          </div>{" "}
                          <span className="ml-3 small-text">
                            <span
                              className="link-text"
                              onClick={() => {
                                setIsBrandLogoAvailable(!isBrandLogoAvailable);
                              }}
                            >
                              (Change Logo)
                            </span>
                          </span>
                        </div>
                      }
                    />
                  </div>
                )}
                <div
                  className={`grow-element theme-light ${classes.growElement} ${
                    isExpanded ? classes.expanded : ""
                  }`}
                >
                  <div className="mb-1">
                    <Typography>
                      {user && !user.logo
                        ? "Upload Your Logo"
                        : "Change or remove your logo"}
                        <span className="sub-text">
                          {" "}
                          (400px by 100px for best results)
                        </span>
                    </Typography>
                  </div>
                  <div
                    className="profile-edit__topbar"
                    style={{ maxWidth: 200, alignItems:"center"}}
                  >
                    <Field
                      name="logo"
                      component={renderDropZoneField}
                      //below props are for dropZone Height & loader
                      SnapShotDropZoneHeight={true}
                      SnapShotDropLoader={true}
                      defaultImage={user.logo ? user.logo : null}
                      callback={handleSaveLogo}
                    />
                    {user && user.logo ?
                      <div
                        className="link-text ml-3 small-text"
                        style={{cursor:"pointer"}}
                        onClick={() => {
                          setIsBrandLogoAvailable(!isBrandLogoAvailable);
                        }}
                      >
                        Cancel
                      </div>
                      : null
                    }
                  </div>
                  
                  <hr />
                </div>
                {!(reportItem && reportItem.hideMarektproofBranding) ?
                <div style={{ width: "100%" }}>
                  <FormControlLabel
                    value="marketproof"
                    control={<WhiteRadio />}
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="logo-container">
                          <img
                            src="https://s3.amazonaws.com/buyerslist/users/image-upload/1718754011_be3bf6835dbc3854f2d0a170e7ee8681.png"
                            style={{ width: 160 }}
                            alt="Marketproof"
                          />
                        </div>
                        <span className="ml-3 small-text"></span>
                      </div>
                    }
                  />
                </div>: null}
                <div style={{ width: "100%" }}>
                  <FormControlLabel
                    value="hide"
                    control={<WhiteRadio />}
                    label="Do Not Display a Logo"
                  />
                </div>
              </RadioGroup>
            </div>
            <div className={classes.root}>
              <div className="mb-2">
                <span className="material-form__label bold">
                  Choose a Contact Method
                </span>
               
                <hr />
              </div>
              <RadioGroup
                aria-label="contact"
                name="contact"
                value={contactFromStorage || localFormValues.contact || "hide"}
                onChange={(e) => handleFieldChange("contact", e.target.value)}
                onClick={(e) => e.stopPropagation()}
              >
                <div>
                  <FormControlLabel
                    value="hide"
                    control={<WhiteRadio />}
                    label="Hide My Profile"
                  />
                </div>
                <div>
                  <FormControlLabel
                    value="show"
                    control={<WhiteRadio />}
                    label="Show My Profile"
                  />
                </div>
              </RadioGroup>
              <hr />
              <div className="sub-text">
                Update your profile in{" "}
                <Link
                  to={`/my-account`}
                  className="link-text"
                  style={{ textDecoration: "underline" }}
                >
                  My Account
                </Link>
              </div>
            </div>
          </Container>
        ) : null}
        {panel == "theme" ? (
          <div className={classes.themeBar}>
            <div className="report-theme">
            <Container className={classes.container} style={{gap:0,justifyContent:"flex-start"}}>
            
                <div className="mb-2 theme-options">
                  <div className="option" onClick={()=>setAdvancedTheme(false)}>
                    {!advancedTheme && <ChevronRightIcon color="#FFF" />} Standard Themes
                  </div>
                 
                  <div className="option" onClick={()=>setAdvancedTheme(true)}>
                    {advancedTheme && <ChevronRightIcon  color="#FFF" />} Custom Options
                  </div>
                </div>
                {!advancedTheme ? 
                  <div className="type-container" style={{padding:"0px 0px 0 20px"}}>
                  <div className="mb-2">
                    <span className="material-form__label bold">
                      Choose a Theme
                    </span>
                    <div className="sub-text">
                      Select a predefined theme
                    </div>
                  
                    <hr />
                  </div>
                  <Slider {...settings} className="">
                    {Object.keys(themes).filter(key => key != "custom").map((themeKey, i) =>  {
                      
                      
                      return Object.keys(customStyles).map((styleKey, i) => {
                        const theme = themes[themeKey];
                        const style = customStyles[styleKey];
                          return (
                            <div
                              onClick={(e) => {
                                handleFieldChange("style", style.id);
                                handleFieldChange("theme", themeKey);
                              }}
                            >
                              <div className={`card ${style.id}`} style={{background:theme.backgroundColor}}>
                                 <div className="accent" style={{background: theme.primaryColor}} />
                                  
                                  <div className="name-container">
                                    <div className="style-name"  style={{ fontFamily : style.font ? style.font : "inherit" }}>
                                      
                                      
                                      {theme.name ? theme.name : _capitalizeText(themeKey)}
                                    </div>
                                    <div className="theme-name" style={{fontFamily: style.bodyFont ? style.bodyFont : "inherit"}}>{style &&
                                    style.name &&
                                    _capitalizeText(style.name)}</div>
                                  </div>
    
                                  <div className="theme-check">
                                   
                                   {style.id == selectedStyle && themeKey == selectedTheme  ? (
                                     <CheckCircleIcon color="#000" size={36} />
                                   ) : (
                                     <CircleIcon color="#000" size={36} />
                                   )}
                                 </div>
                                </div>
                              </div>
                          );
                        })
                    })}
                  </Slider>
                  </div>
                :
                <div className="type-container" style={{display:"flex",width:"100%",gap:"30px"}}>
                  <div className={"custom-style-options"}>
                    <div className="mb-2">
                      <span className="material-form__label bold">
                        Select a Style
                      </span>
                      <div className="sub-text">
                        Change the look and feel
                      </div>
                      <hr />
                    </div>
                    {Object.keys(customStyles).map((key, i) => {
                      const style = customStyles[key];
                  
                      return (
                        <div
                          onClick={(e) => {
                            handleFieldChange("style", style.id);
                          }}
                          className={"style-select"}
                        >
                          {style.id == selectedStyle ? (
                             <CheckCircleIcon color="#FFF" size={36} />
                           ) : (
                             <CircleIcon color="#FFF" size={36} />
                           )}
                          <div className="custom-style">
                            <h3 style={{fontFamily : style.font ? style.font : "inherit"}} >{style &&
                              style.name &&
                              _capitalizeText(customStyles[key].name)}</h3>
                            <p style={{fontFamily : style.bodyFont ? style.bodyFont : "inherit"}} >Body Font</p>
                          </div>
                        </div>
                      );
                    })}
               
                  </div>
                  
                  <div>
                    <div className="mb-2">
                      <span className="material-form__label bold">
                        Pick Colors
                      </span>
                      <div className="sub-text">
                        Change color scheme
                      </div>
                    
                      <hr />
                    </div>
                    <div>
                      
                     <div className={"use-custom-options"}
                          onClick={(e) => {
                             handleFieldChange("theme", "custom");
                             
                           }}>
                       <div className="custom-check">
                         {"custom" == selectedTheme ? (
                           <CheckCircleIcon color="#FFF" size={36} />
                         ) : (
                           <CircleIcon color="#FFF" size={36} />
                         )}
                       </div>
                       <div>
                         <div className="color-header">Use Custom Colors</div>
                         <div className={"custom-color-types"}>
                           <div className="color-type">
                             <div className="color-type-name">Accent</div>
                             <div className="color-area" style={{ background: color }}
                              onClick={(e)=> {
                                 setIsBackgroundColorPickerOpen(false);
                                 setIsTextColorPickerOpen(false);
                                 setIsColorPickerOpen(true);
                              }}
                             >
                               {isColorPickerOpen &&
                                 localFormValues &&
                                 localFormValues.theme &&
                                 localFormValues.theme == "custom" ? (
                                 <div className="report-color-picker" ref={colorPickerRef}>
                                   <HexColorPicker color={color} onChange={setColor} />
                                   <HexColorInput
                                     className="hex-input"
                                     color={color}
                                     onChange={setColor}
                                   />
                                 </div>
                               ) : null}
                             </div>
                           </div>
                           <div className="color-type">
                              <div className="color-type-name">Text</div>
                              <div className="color-area" style={{ background: textColor }}
                               onClick={(e)=> {
                                  setIsBackgroundColorPickerOpen(false);
                                  setIsTextColorPickerOpen(true);
                                  setIsColorPickerOpen(false);
                               }}
                              >
                                {isTextColorPickerOpen &&
                                 localFormValues &&
                                 localFormValues.theme &&
                                 localFormValues.theme == "custom" ? (
                                   <div className="report-color-picker" ref={textColorPickerRef}>
                                     <HexColorPicker color={textColor} onChange={setTextColor} />
                                     <HexColorInput
                                       className="hex-input"
                                       color={textColor}
                                       onChange={setTextColor}
                                     />
                                   </div>
                                 ) : null}
                              </div>
                            </div>
                            <div className="color-type">
                              <div className="color-type-name">Background</div>
                              <div className="color-area" style={{ background: backgroundColor }}
                               onClick={(e)=> {
                                  setIsBackgroundColorPickerOpen(true);
                                  setIsTextColorPickerOpen(false);
                                  setIsColorPickerOpen(false);
                               }}
                              >
                                {isBackgroundColorPickerOpen &&
                                 localFormValues &&
                                 localFormValues.theme &&
                                 localFormValues.theme == "custom" ? (
                                   <div className="report-color-picker" ref={backgroundColorPickerRef}>
                                     <HexColorPicker color={backgroundColor} onChange={setBackgroundColor} />
                                     <HexColorInput
                                       className="hex-input"
                                       color={backgroundColor}
                                       onChange={setBackgroundColor}
                                     />
                                   </div>
                                 ) : null}
                              </div>
                            </div>
                         </div>
                       </div>
                     </div>
                    </div>
                  </div>
                  
                 </div>
         
              }
            </Container>
             
            </div>
           
          </div>
        ) : null}
        {false && panel == "theme" ? (
          <div className={classes.themeBar}>
            <div className="report-theme">
            <Container className={classes.container}>
              <div className={classes.root} style={{ width: 420 }}>
                <div
                  style={
                    isExpanded ? { marginBottom: 0 } : { marginBottom: "20px" }
                  }
                >
                  <div className="mb-2">
                    <span className="material-form__label bold">
                      Select a Style
                    </span>
                    <div className="sub-text">
                      Change the look and feel of your download
                    </div>
                    <hr />
                  </div>
                </div>
            
                <Slider {...settings} className="">
                  {Object.keys(customStyles).map((key, i) => {
                    const style = customStyles[key];
                
                    return (
                      <div
                        onClick={(e) => {
                          handleFieldChange("style", style.id);
                        }}
                      >
                        <div
                          className="style_card"
                        >
                      <div className="style_card_inner">
                            <div className="style-name"  style={{ background: style.backgroundColor, color:style.color, fontFamily : style.font ? style.font : "inherit" }}>
                              <h3 style={{fontFamily : style.font ? style.font : "inherit"}} >{style &&
                                style.name &&
                                _capitalizeText(customStyles[key].name)}</h3>
                              <p style={{fontFamily : style.bodyFont ? style.bodyFont : "inherit"}} >Body</p>
                            </div>
                            <div className="theme-check">
                             
                             {style.id == selectedStyle ? (
                               <CheckCircleIcon color="#000" size={36} />
                             ) : (
                               <CircleIcon color="#000" size={36} />
                             )}
                           </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
              <div className={classes.root}>
                <div className="mb-2">
                  <span className="material-form__label bold">
                    Choose a Color
                  </span>
                  <div className="sub-text">
                    Pick a color or define your own
                  </div>
            
                  <hr />
                </div>
                <div>
                <div className="sub-text bold mb-2">
                  Use a predefined color scheme
                </div>
                <div style={{display:"flex", gap:"5px", flexWrap:"wrap",alignItems:"flex-start"}}>
                 {Object.keys(themes).filter(key => key != "custom").map((key, i) => {
                   const theme = themes[key];
               
                   return (
                     <div
                       onClick={(e) => {
                         handleFieldChange("theme", key);
                         if (key == "custom" && !isColorPickerOpen) {
                           setIsColorPickerOpen(true);
                         }
                       }}
                       style={{height:40}}
                     >
                       <div
                         className="color-option"
                         style={{background: theme.primaryColor}}
                       >
                         <div
                           className="accent"
                           style={{
                             background:
                               key == "custom" ? color : key == "dark" ? "#000" : "#FFF" ,
                           }}
                         />
                         {/* <div className="theme-name">
                           {theme.name ? theme.name : _capitalizeText(key)}
                         </div>
                         */}
                         <div className="theme-check">
                           {key == selectedTheme ? (
                             <CheckCircleIcon color={key == "dark" ? "#000" : "#FFF"} size={36} />
                           ) : (
                             <CircleIcon color={key == "dark" ? "#000" : "#FFF"}  size={36} />
                           )}
                         </div>
                       </div>
                     </div>
                   );
                 })}
                 </div>
                 <hr/>
                 <div>
                  <div className="sub-text bold mb-2">
                    Or select custom colors
                  </div>
                  <div style={{display:"flex", gap:"5px", flexWrap:"wrap",alignItems:"flex-start"}}>
                    
                     <div className={"custom-option"}>
                        <div
                           onClick={(e) => {
                             handleFieldChange("theme", "custom");
                             setIsBackgroundColorPickerOpen(false);
                             setIsTextColorPickerOpen(false);
                             setIsColorPickerOpen(true);
                             
                           }}
                           style={{height:40,display:"inline-block"}}
                         >
                           <div
                             className="color-option"
                             style={{background:color}}
                           >
                             
                              <div className="theme-check">
                               {"custom" == selectedTheme ? (
                                 <CheckCircleIcon color="#000" size={36} />
                               ) : (
                                 <CircleIcon color="#000" size={36} />
                               )}
                             </div>
                            
                           </div>
                           {isColorPickerOpen &&
                            localFormValues &&
                            localFormValues.theme &&
                            localFormValues.theme == "custom" ? (
                              <div className="report-color-picker" ref={colorPickerRef}>
                                <HexColorPicker color={color} onChange={setColor} />
                                <HexColorInput
                                  className="hex-input"
                                  color={color}
                                  onChange={setColor}
                                />
                              </div>
                            ) : null}
                         </div>
                         <div>Primary</div>
                     </div>
                     <div className={"custom-option"}>
                     <div
                        onClick={(e) => {
                          handleFieldChange("theme", "custom");
                          setIsColorPickerOpen(false);
                          setIsBackgroundColorPickerOpen(false);
                          setIsTextColorPickerOpen(true);
                          
                        }}
                        style={{height:40,display:"inline-block"}}
                      >
                        <div
                          className="color-option"
                          style={{background:textColor}}
                        >
                          
                          <div className="theme-check">
                            {"custom" == selectedTheme ? (
                              <CheckCircleIcon color="#000" size={36} />
                            ) : (
                              <CircleIcon color="#000" size={36} />
                            )}
                          </div>
                          
                        </div>
                        {isTextColorPickerOpen &&
                         localFormValues &&
                         localFormValues.theme &&
                         localFormValues.theme == "custom" ? (
                           <div className="report-color-picker" ref={textColorPickerRef}>
                             <HexColorPicker color={textColor} onChange={setTextColor} />
                             <HexColorInput
                               className="hex-input"
                               color={textColor}
                               onChange={setTextColor}
                             />
                           </div>
                         ) : null}
                      </div>
                        <div>Text</div>
                      </div>
                      <div className={"custom-option"}>
                       <div
                          onClick={(e) => {
                            handleFieldChange("theme", "custom");
                            setIsColorPickerOpen(false);
                            setIsTextColorPickerOpen(false);
                            setIsBackgroundColorPickerOpen(true);
                            
                            
                          }}
                          style={{height:40,display:"inline-block"}}
                        >
                          <div
                            className="color-option"
                            style={{background:backgroundColor}}
                          >
                            
                            <div className="theme-check">
                              {"custom" == selectedTheme ? (
                                <CheckCircleIcon color="#000" size={36} />
                              ) : (
                                <CircleIcon color="#000" size={36} />
                              )}
                            </div>
                            
                          </div>
                          {isBackgroundColorPickerOpen &&
                           localFormValues &&
                           localFormValues.theme &&
                           localFormValues.theme == "custom" ? (
                             <div className="report-color-picker" ref={backgroundColorPickerRef}>
                               <HexColorPicker color={backgroundColor} onChange={setBackgroundColor} />
                               <HexColorInput
                                 className="hex-input"
                                 color={backgroundColor}
                                 onChange={setBackgroundColor}
                               />
                             </div>
                           ) : null}
                        </div>
                          <div>Background</div>
                        </div>
                  </div>
                  
                 </div>
                 </div>
                <hr />
                
              </div>
            </Container>
              {/* Font Selector */}
              {/* <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel>Font</InputLabel>
                <Select
                  value={selectedFont}
                  onChange={(e) => setSelectedFont(e.target.value)}
                  label="Font"
                >
                  {googleFonts.map((font) => (
                    <MenuItem key={font} value={font} style={{ fontFamily: font }}>
                      {font}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              
              
              
            </div>
           
          </div>
        ) : null}
      </form>
      <SnackBar
        snackShow={snackShow.show}
        snackMessage={snackShow.message}
        snackClose={snackClose}
        snackDuration={5000}
        snackType={snackShow.type}
      />
    </>
  );
};

ExportSettingsForm.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.object,
  classes: PropTypes.object.isRequired,
  setPreview: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    formLogo: getFormValues("snapshot-logo")(state),

    // formValues: getFormValues("exportSettings")(state),
    user: state.user,
  };
};

const formWrapped = reduxForm({
  form: "snapshot-logo", // a unique identifier for this form
})(ExportSettingsForm);

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(formWrapped)
);
